<template>
  <div>
    <div v-for="item in lineItems" :key="item.id" class="cost-item">
      <div class="cost-label">{{ item.costName }}</div>
      <div class="d-flex">
        <div class="cost-rate">{{ item.costRate }}</div>
        <div class="cost-amount">
          {{ item.amount | currency(item.currencyCode) }}
        </div>
      </div>
    </div>
    <div class="cost-item font-weight-bold">
      <div class="cost-label">Total Worker Cost</div>
      <div class="d-flex">
        <div class="cost-rate"></div>
        <div class="cost-amount">
          {{ totalAmount | currency(totalCurrency) }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "PayRateItems",
  props: {
    payRateItems: { type: Array, default: () => [] },
    rate: { type: Object, default: null }
  },
  computed: {
    lineItems() {
      const nonTotals = (this.payRateItems || []).filter(
        i => (i.costName || "").toLowerCase() !== "total worker cost"
      );
      const seen = new Set();
      return nonTotals.filter(i => {
        const key = `${(i.costName || "").toLowerCase()}|${i.costDisplayOrder}`;
        if (seen.has(key)) return false;
        seen.add(key);
        return true;
      });
    },
    apiTotalItem() {
      return (
        (this.payRateItems || []).find(
          i => (i.costName || "").toLowerCase() === "total worker cost"
        ) || null
      );
    },
    totalAmount() {
      if (this.rate && Number.isFinite(this.rate.amount))
        return this.rate.amount;
      if (this.apiTotalItem) return this.apiTotalItem.amount;
      return this.lineItems.reduce((sum, i) => sum + (i.amount || 0), 0);
    },
    totalCurrency() {
      return (
        (this.rate && this.rate.currencyCode) ||
        (this.apiTotalItem && this.apiTotalItem.currencyCode) ||
        (this.payRateItems[0] && this.payRateItems[0].currencyCode) ||
        "GBP"
      );
    }
  }
};
</script>
